import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AssetsCustomActionSchemaWithId } from '@iconik-io/iconik-api/src/services/assets';

import type { CustomActionsContexts, CustomActionsState } from './types';

const groupByContext = (
  customActions: AssetsCustomActionSchemaWithId[],
): CustomActionsContexts => {
  const customActionsContexts: CustomActionsContexts = {
    NONE: [],
    SAVED_SEARCH: [],
    COLLECTION: [],
    ASSET: [],
    SHARED_ASSET: [],
    SHARED_COLLECTION: [],
    PLAYLIST: [],
    SHARED_PLAYLIST: [],
    BULK: [],
    ASSET_SUBCLIP: [],
  };
  customActions.forEach((customAction) => {
    const { context } = customAction;
    if (context && customActionsContexts[context]) {
      customActionsContexts[context].push(customAction);
    }
  });
  return customActionsContexts;
};

const initialState: CustomActionsState = {
  customActions: [],
  customActionsContexts: groupByContext([]),
};

export const customActionsSlice = createSlice({
  name: 'customActions',
  initialState,
  reducers: {
    setCustomActions(
      state,
      action: PayloadAction<AssetsCustomActionSchemaWithId[]>,
    ) {
      state.customActions = action.payload;
      state.customActionsContexts = groupByContext(action.payload);
    },
    upsertCustomAction(
      state,
      action: PayloadAction<AssetsCustomActionSchemaWithId>,
    ) {
      const index = state.customActions.findIndex(
        (customAction) => customAction.id === action.payload.id,
      );
      if (index === -1) {
        state.customActions.push(action.payload);
      } else {
        state.customActions[index] = action.payload;
      }
      state.customActionsContexts = groupByContext(state.customActions);
    },
    removeCustomActions(state, action: PayloadAction<string[]>) {
      state.customActions = state.customActions.filter(
        (customAction) => !action.payload.includes(customAction.id),
      );
      state.customActionsContexts = groupByContext(state.customActions);
    },
  },
});

export const { setCustomActions, upsertCustomAction, removeCustomActions } =
  customActionsSlice.actions;

export const customActionsReducer = customActionsSlice.reducer;
